import React, { useEffect, useState } from "react";

import {
  createStyles,
  createTheme,
  makeStyles,
} from "@material-ui/core/styles";
import { Theme, Typography } from "@material-ui/core";

// import {TabPanel} from '@material-ui/lab';
// Icon
import {
  QueryClientProvider,
  useQuery,
  useQueryClient,
  useQueryErrorResetBoundary,
} from "react-query";
import getVehiclesEntrances from "../requests/getVehiclesEntrances";
import { DriverCard } from "../components/driverCard";
import { HistoryCard } from "./historyCard";
import getVehiclesHistory from "../requests/getVehiclesHistory";
import getHistoryByFilters from "../requests/getHistoryByFilters";
import { flattenObject, removeEmptyValueObject } from "../../../utils/helpers";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    driverCard: {
      marginTop: "56px",
    },
    infoIcon: {
      color: "inherit",
    },
    infoSection: {
      color: "#2f4858",
      padding: "8px",
    },
    infoBar: {
      flexShrink: 1,
      display: "inline",
    },
    namePlateText: {
      paddingLeft: "8px",
      fontSize: "18px",
    },
    namePlateNumber: {
      paddingLeft: "8px",
      fontSize: "14px",
    },
    namePlate: {
      flexShrink: 1,
      display: "flex",
      flexDirection: "column",
      paddingBottom: "8px",
    },
    parentGrid: {
      minWidth: "100%",
      backgroundColor: "white",
      padding: "0px",
      marginTop: "16px",
    },
    idBar: {
      display: "flex",
    },
    profileImage: {
      maxWidth: "48px",
      maxHeight: "48px",
      borderRadius: "50%",
    },
    root: {
      marginTop: "30px",
    },
  })
);

export const EntrancesHistoryMobView = (props: any) => {
  const classes = useStyles();
  const queryClient = useQueryClient();
  const filter = new URLSearchParams(window.location.search).get("filter")

  let filterParams;

  useEffect(() => {
    filterParams = {
      ...removeEmptyValueObject(flattenObject(props.filtersDrill)),
      "pageNumber": "1",
      "size": "50",
      "sort": "id,desc",
      'vehicleEntranceType.equals': filter,
    };
  });

  const {
    isLoading: filterHistoryIsLoading,
    error: filterError,
    data: filteredHistory,
  } = useQuery(
    ["filteredHistory", filterParams],
    () => getHistoryByFilters(filterParams),
    {},
  );

  // const {
  //   isLoading,
  //   error,
  //   data: vehiclesHistory,
  // } = useQuery('vehiclesHistory', getVehiclesHistory);

  if (filterHistoryIsLoading) {
    return <Typography>شکیبا باشید</Typography>;
  }
  // if (error) {
  //   console.error(error.message);
  // }

  //give the child whatever u take from requests

  // if (!filterParams) {
  //   console.log('nofilter', filterParams)
  //   return vehiclesHistory?.data.map((vehicle: any) => {
  //     return <HistoryCard vehicle={vehicle} className={classes.driverCard} />;
  //   });
  // } else if (filterParams) {
  //   console.log("filtered", filterParams)
  //   return filteredHistory?.data.map((vehicle: any) => {
  //     return <HistoryCard vehicle={vehicle} className={classes.driverCard} />;
  //   });
  // }
  return filteredHistory?.data.map((vehicle: any) => {
    return <HistoryCard vehicle={vehicle} className={classes.driverCard} />;
  });
};
// <img className={classes.profileImage} src="https://media.istockphoto.com/vectors/default-avatar-photo-placeholder-icon-grey-profile-picture-business-vector-id1327592506" />

// {
//           <img
//             className={classes.profileImage}
//             src={vehicles.driver.photo}
//           />
//         }

// <Grid container className={classes.infoSection}>
//           <Grid item xs={2} spacing={1} className={classes.infoBar}>
//             <Icon path={mdiArchiveOutline} size={1} className={classes.infoIcon} />
//           </Grid>
//
//           <Grid item xs={4} spacing={1} className={classes.infoBar}>
//             <Typography variant="body1">notDefined</Typography>
//           </Grid>
//         </Grid>
//
